import { createSelector } from 'reselect';

import { getStringProp } from '@mews/fp';

import {
    getEndDate,
    getEndTimeUtc,
    getStartDate,
    getStartTimeUtc,
    getVoucherCode,
} from '../../modules/resourceOrder/selectors';
import { getServiceAvailabilitiesInLegacyFormat } from '../../modules/serviceAvailability/selectors';
import { AvailabilityValue } from '../../types/data';
import { getAvailabilityValue } from '../../utils/availabilityHelpers';

export const getCurrentDateEnterpriseAvailability = createSelector(
    getServiceAvailabilitiesInLegacyFormat,
    getStartDate,
    getEndDate,
    getStringProp('enterpriseId'),
    getVoucherCode,
    getStartTimeUtc,
    getEndTimeUtc,
    (
        availability,
        startDate,
        endDate,
        enterpriseId,
        voucherCode,
        startTimeUtc,
        endTimeUtc
    ): AvailabilityValue | Partial<AvailabilityValue> =>
        startDate != null && endDate != null
            ? getAvailabilityValue({
                  availability,
                  startDate,
                  endDate,
                  enterpriseId,
                  voucherCode,
                  startTimeUtc,
                  endTimeUtc,
              })
            : {}
);
